import React, { Component } from 'react';
import { connect } from 'react-redux';
import { cekCookies } from '../../../../actions';
import __ from 'lodash';
import Loader from '../../../Loader';
import LoaderModal from '../../../modal/LoaderModal';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { CONFIG, CONFIG_UTIL } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import utilManagement from '../../../../apis/utilManagement';
import { Row, Col } from 'react-bootstrap';
import DropdownTahunAjaran from '../masterDropDown/DropdownTahunAjaran';
import DropdownKelasKapital from '../masterDropDown/DropdownKelasKapital';
import DropdownKelasParalel from '../masterDropDown/DropdownKelasParalel';
import DropdownProfilCbt from '../masterDropDown/DropdownProfilCbt';
import DropdownJadwalProfilCbt from '../masterDropDown/DropdownJadwalProfilCbt';
import ReportHwEntity from '../../../../entity/ReportHwEntity';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import QuestionAnswerOutlinedIcon from '@material-ui/icons/QuestionAnswerOutlined';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';

class Homework extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            isLoading: false,
            idSekolah: null,
            idGuru: null,
            idProfilHw: null,
            idKelasParalel: null,
            kodeTa: null,
            namaProfil: null,
            namaMapel: null,
            namaGuru: null,
            essay: 0,
            idSubProfilCbt: null,
            guruKelas: [],
            ta: [],
            KelasParalelSearch: [],
            SiswaKelasParalel: [],
            profilHw: [],
            jadwalProfil: [],
            dataReport: [],
            dialogShow: false,
            alertShow: false,
            alertMessage: ''
        };
    }

    async componentDidMount() {
        document.title = "Report Homework"; 
        console.clear();
        console.time("Time componentDidMount");
        this.setState({
            isFetching: true
        });
        
        await this.props.cekCookies();    
        if(!__.isEmpty(this.props.account)) {
            this.setState({
                params: {
                    idSekolah: this.props.account.idSekolah,
                    idGuru: this.props.account.idGuru
                }
            })
        } 

        var historyState = this.props.location.state;
        if( historyState !== undefined) {
            this.setState({
                selectedKelas: historyState.selectedKelas,
                idKelasParalel: historyState.idKelasParalel,
                idProfilHw: historyState.idProfilHw,
                idJadwalProfil: historyState.idJadwalProfil
            })

            this.fetchKelasParalel(historyState.selectedKelas);
            this.fetchProfilHw();
            this.fetchJadwalhw(historyState.idProfilHw);
            this.showReportHw();
        }
        this.fetchTa();
        this.fetchKelas();

        this.setState({
            isFetching: false
        });
        console.timeEnd("Time componentDidMount");
    }

    fetchTa = async () => {
        // Fetch Tahun Ajaran
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN)
        .catch(function(error) {
            console.error('Error Tahun Ajaran', error);
        });
        console.info('Fetch Tahun Ajaran', resTa);

        if(resTa) {
            if(resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    ta: resTa.data.data
                })
            }
        }

        resTa.data.data.map((val) => {
            console.log('tahun ajaran', val)
            if(val.status === "1") {
                this.setState({
                    kodeTa: val.kodeTahunAjaran
                })
            }
        })
    }

    hanldeOnChangeTa = async (e) => {
        console.clear();
        console.time("Time hanldeOnChangeTa");
        var targetValue = e.target.value;
        
        this.state.idKelasParalel = null;
        this.state.idProfilHw = null;
        this.state.idJadwalProfil = null;
        this.state.KelasParalelSearch = [];
        this.state.profilHw = [];
        this.state.dataReport = [];
        this.state.jadwalProfil = [];

        this.setState({
            selectedKelas: null,
            // idKelasParalel: null,
            // idProfilHw: null,
            kodeTa: targetValue,
        });
        console.timeEnd("Time hanldeOnChangeTa");
    }

    fetchKelas = async () => {
        this.setState({isFetching: true});

        // fetch guru kelas dulu sek gan....
        const resGuruKelas = await accountManagement.get(CONFIG.GET_KELAS_BY_GURU + this.props.account.idGuru)
        .catch(function(error) {
            console.error('Error Get Kelas by Guru', error);
        })

        if(resGuruKelas) {
            if(resGuruKelas.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    guruKelas: resGuruKelas.data.data
                })
            }
        }
    }

    fetchKelasParalel = async(id) => {
        this.state.KelasParalelSearch = [];
        const resKelasParalel = await accountManagement.get(CONFIG.GURU_GET_KELASPARALEL_BY_KELAS + id)
        .catch (function(error) {
            console.error('Error Get Kelas Paralel', error);
        })

        // masukan kelas paralel ke  dropdown
        if(resKelasParalel) {
            if(resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    KelasParalelSearch: resKelasParalel.data.data
                })
            }
        }
    }

    fetchProfilHw = async() => {
        this.state.profilHw = [];
        const resProfilHwGuru = await accountManagement.get(CONFIG.HW_GET_PROFIL_GURU + this.state.selectedKelas)
        .catch (function(error) {
            console.error('Error Get Profil HW', error);
        })

        // Masukan ProfilHwGuru ke Dropdown
        if(resProfilHwGuru) {
            if(resProfilHwGuru.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    profilHw: resProfilHwGuru.data.data.dataProfil
                })
            }
        }
    }

    fetchJadwalhw = async(id) => {
        this.state.dataReport=[];
        this.state.jadwalProfil=[];
        const resJadwalProfilHwGuru = await accountManagement.get(CONFIG.HW_GET_JADWAL_PROFIL_GURU +id)
        .catch (function(error) {
            console.error('Error Get Jadwal Profil HW', error);
        })

        // masukan ke dropdown
        if(resJadwalProfilHwGuru) {
            if(resJadwalProfilHwGuru.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    jadwalProfil: resJadwalProfilHwGuru.data.data.dataJadwalProfil
                })
            }
        }
    }

    handleOnChangeKelas = async (idKelas) => {
        console.clear();
        console.time("Time handleOnChangeKelas");
        this.setState({
            isFetching: true
        });

        this.state.selectedKelas = idKelas.target.value;
        this.state.idKelasParalel = null;
        this.state.idProfilHw = null;
        this.state.idJadwalProfil = null;
        this.state.KelasParalelSearch = [];
        this.state.profilHw = [];
        this.state.dataReport = [];
        this.state.jadwalProfil = [];        
        
        // fetch kelas pararelnya dulu
        this.fetchKelasParalel(idKelas.target.value);     
        
        // fetch profil HW yg dibikin guru
        this.fetchProfilHw();

        this.setState({
            isFetching: false
        });
        console.timeEnd("Time handleOnChangeKelas");
    }

    handleOnChangeKelasParalel = async (kode) => {
        console.clear();
        console.time("Time handleOnChangeKelasParalel");
        this.setState({
            idKelasParalel: kode.target.value
        });
        console.timeEnd("Time handleOnChangeKelasParalel");
    }

    hanldeOnChangeHw = async (e) => {
        console.clear();
        console.time("Time hanldeOnChangeHw");
        this.setState({
            isFetching: true
        });
        
        this.state.idProfilHw = e.target.value;    
        this.state.idJadwalProfil = null;    
        this.state.dataReport = [];
        this.state.jadwalProfil = [];
        
        // fetch Jadwal profil HW yg dibikin guru
        this.fetchJadwalhw(e.target.value)
        
        this.setState({
            isFetching: false
        });
        console.timeEnd("Time hanldeOnChangeHw");
    }    

    hanldeOnChangeJadwalProfilCbt = async (id)=> {
        this.setState({
            idJadwalProfil: id.target.value
        })
    }

    showReportHw = async (e) => {
        this.setState({
            dataReport: [],
            namaGuru: null,
            namaMapel : null,
            essay : null,
            idSubProfilCbt: null
        });
        
        if(this.state.idKelasParalel !== null && this.state.idProfilHw !== null) {
            // this.setState({isFetching: true})
            this.setState({
                isLoading: true
            });
            
            // fetch report
            const response = await accountManagement.post(CONFIG.HW_REPORT_BY_KP, {...ReportHwEntity,
                kodeTa: this.state.kodeTa,
                idProfil: this.state.idProfilHw,
                idKp: this.state.idKelasParalel,
                idJadwalProfil: this.state.idJadwalProfil
            })
            .catch(function(error) {
                console.error('Error HW_REPORT_BY_KP', error);
            });

            // masukan kelas paralel ke  dropdown
            if(response) {
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        dataReport: response.data.data.dataReport,
                        namaGuru: response.data.data.detailGuru.NAMA_GURU,
                        namaMapel : response.data.data.dataSubProfil.namaSubProfil,
                        essay : response.data.data.dataSubProfil.prosentaseEssay,
                        idSubProfilCbt: response.data.data.dataSubProfil.idSubProfilCbt
                    })
                }
            }
            this.setState({
                isLoading: false
            });
        }
        else {
            alert('Data belum lengkap');
        }
    }

    koreksiEssay = (idSubHeaderCbt, idSiswa) => {
        this.props.history.push({
            pathname: '/essaysiswa/' + idSubHeaderCbt + '/' + idSiswa,
            state: {
                selectedKelas: this.state.selectedKelas,
                idKelasParalel: this.state.idKelasParalel,
                idProfilHw: this.state.idProfilHw,
                idJadwalProfil: this.state.idJadwalProfil,
                prosentaseEssay: this.state.essay
            }
        })
    }

    resetStatusPengerjaan = async(idSubHeader) => {
        if(window.confirm('Reset Status Pengerjaan Siswa... ?')) {
            this.setState({isLoading: true})
            const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_RESET_CBT_SISWA, idSubHeader === null ? 0 : idSubHeader)
            .catch (function(error){ console.log(error) })
            if(response){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {   
                    let data = [...this.state.dataReport];
                    let index = data.findIndex(obj => obj.idSubHeaderCbt === idSubHeader);
                    data[index].statusPengerjaan = '0';
                    this.setState({data});
                }
                this.setState({                
                    alertShow: true,
                    alertMessage: response.data.errorSchema.errorMessage,
                    isLoading: false
                });
            }
        } 
    }

    resetTimer = async(idSiswa) => {
        console.info(idSiswa);
        if(window.confirm('Reset Waktu Pengerjaan Siswa... ?')) {
            this.setState({ isLoading: true })
            const response = await utilManagement.delete(CONFIG_UTIL.UTIL_RESET_TIMER_SISWA + 
                this.state.idProfilHw + '/' + this.state.idSubProfilCbt + '/' + idSiswa + '/' + this.state.idJadwalProfil)
            .catch(function(error) {
                console.info(error);
            });
            
            if(response) {
                this.setState({                
                    alertShow: true,
                    alertMessage: response.data.message,
                    isLoading: false
                });                
            }
            
        } 
    }

    renderListReport() {
        if(!__.isEmpty(this.state.dataReport)) {
            return this.state.dataReport.map((g,i) => {
                return (
                    <tr key={i}>
                        <td>{i+1}</td>
                        <td>{g.namaSiswa}</td>
                        <td>{g.jumlahSoal}</td>
                        <td>{g.benar}</td>
                        <td>{g.salah}</td>
                        <td>{g.skor}</td>
                        <td>
                            {g.statusPengerjaan === "0" ? 
                                <button className="btn btn-danger btn-sm" title="Belum selesai/mengumpulkan"><li className="fa fa-window-close"></li></button>
                                :
                                <button className="btn btn-info btn-sm" title="Sudah selesai/mengumpulkan"><li className="fa fa-check-square"></li></button>
                            }
                        </td>
                        <td>
                            {/* <div className="btn-group" style={{width:'100%'}}>
                                <button className="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                                    Action
                                </button>
                                <div className="dropdown-menu">
                                    {this.state.essay !== 0
                                    &&
                                        <div>
                                            {g.idSubHeaderCbt === null ? 
                                                <button className="btn dropdown-item" disabled title="Belum ada hasil Homework">KoreksiEssay</button>
                                                :
                                                <button className="btn dropdown-item" onClick={() => this.koreksiEssay(g.idSubHeaderCbt, g.idSiswa)}>Koreksi Essay</button>
                                            }
                                            <div className="dropdown-divider"></div>
                                        </div>
                                    }                                   
                                    
                                    
                                    <button className="btn dropdown-item" onClick={e=> this.resetTimer(g.idSiswa)}>Reset Timer</button>
                                    <div className="dropdown-divider"></div>
                                    
                                    {
                                        g.idSubHeaderCbt === null || g.statusPengerjaan === '0' ? 
                                        <button className="btn dropdown-item" disabled>Reset Status</button>
                                        :
                                        <button className="btn dropdown-item" onClick={e=> this.resetStatusPengerjaan(g.idSubHeaderCbt)}>Reset Status</button>
                                    }
                                </div>
                            </div>   */}
                            <ButtonGroup size="small" color="primary" aria-label="small outlined button group">
                                {this.state.essay !== 0
                                    &&
                                    <Button
                                        disabled={g.idSubHeaderCbt === null ? false : true }
                                        onClick={() => this.koreksiEssay(g.idSubHeaderCbt, g.idSiswa)}
                                        >
                                            Koreksi Essay
                                    </Button> 
                                }
                                
                                <Button
                                    disabled={g.idSubHeaderCbt === null || g.statusPengerjaan === '0' ? false :  true}
                                    onClick={e=> this.resetStatusPengerjaan(g.idSubHeaderCbt)}
                                    >
                                        Reset Status
                                </Button> 
                            </ButtonGroup>
                            
                            
                            
                        </td>
                    </tr>
                )
            })
        }
        else {
            return (
                <tr>
                    <td colSpan="8" align="center">Tidak ada data</td>
                </tr>
            )
        }   
    }
    
    render() {
        console.groupCollapsed('Cek State/Props ReportHw');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();

        return(  
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching}/> 
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'Report Homework'}/> 
                    
                    <Row>
                        <Col>
                            <select className="form-control" name="kodeTa" value={this.state.kodeTa} onChange={this.hanldeOnChangeTa} required>
                                <option value="" selected disabled>~~ Pilih Tahun Ajaran ~~</option>
                                <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                            </select>
                        </Col> 
                        
                        <Col>                            
                            <select className="form-control" value={this.state.selectedKelas === null ? "" : this.state.selectedKelas} onChange={this.handleOnChangeKelas} required>
                                <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                <DropdownKelasKapital kelas={this.state.guruKelas} />
                            </select>
                        </Col>

                        <Col>                         
                            <select className="form-control" value={this.state.idKelasParalel === null ? "" : this.state.idKelasParalel} onChange={this.handleOnChangeKelasParalel} required>
                                <option value="" selected disabled>~~ Pilih Kelas Paralel ~~</option>
                                <DropdownKelasParalel kelasParalel={this.state.KelasParalelSearch}  />
                            </select>
                        </Col>

                        <Col>
                            <select className="form-control" value={this.state.idProfilHw === null ? "" : this.state.idProfilHw} onChange={this.hanldeOnChangeHw} required>
                                <option value="" selected disabled>~~ Pilih Profil Homework ~~</option>
                                <DropdownProfilCbt profil={this.state.profilHw} />
                            </select>
                        </Col>

                        <Col>
                            <select className="form-control" value={this.state.idJadwalProfil === null ? "" : this.state.idJadwalProfil} onChange={this.hanldeOnChangeJadwalProfilCbt} required>
                                <option value="" selected disabled>~~ Pilih Jadwal Homework ~~</option>
                                <DropdownJadwalProfilCbt jadwalProfil={this.state.jadwalProfil}  />
                            </select>
                        </Col>
                        
                        <Col md={1} className="text-right">
                            <button className="btn btn-primary" onClick={this.showReportHw}><i className="fa fa-search"> Cari</i></button>
                        </Col>
                    </Row>

                    <div class="clearfix visible-xs-block">
                        <br></br>
                    </div>
                    
                    {
                        this.state.idProfilHw && this.state.idJadwalProfil && this.state.idKelasParalel
                        &&
                        <div className="row">
                            <div className="col-md-4">&nbsp;</div>
                            
                            <div className="col-md-8 text-right">
                                <button className="btn btn-primary" title="REPORT PDF" onClick={()=> window.open("reporthwkelas/" + this.state.idProfilHw + "/" + this.state.idJadwalProfil + "/" + this.state.idKelasParalel + "/" + this.state.kodeTa, "_blank")}>
                                    <i className="fa fa-file-pdf-o">&nbsp; Report</i>
                                </button>
                                &nbsp;
                                <button className="btn btn-primary" title="REPORT EXCEL" onClick={()=> window.open("reporthwkelasexcel/" + this.state.idProfilHw + "/" + this.state.idJadwalProfil + "/" + this.state.idKelasParalel + "/" + this.state.kodeTa, "_blank")}>
                                    <i className="fa fa-file-excel-o">&nbsp; Report</i>
                                </button>
                                &nbsp;
                                <button className="btn btn-primary" onClick={()=> window.open("reporthwdetail/" + this.state.idProfilHw + "/" + this.state.idJadwalProfil + "/" + this.state.idKelasParalel + "/" + this.state.kodeTa, "_blank")}>
                                    <i className="fa fa-file-pdf-o">&nbsp; Detail Jawaban</i>
                                </button>
                            </div>
                        </div>
                    }
                    
                    <div> 
                        {!this.state.isLoading &&
                            <div className="mt-2">
                                <div className="row">
                                    <div className="col-md-4">                            
                                        <b>Nama Guru: {this.state.namaGuru}</b>
                                    </div>

                                    <div className="col-md-4">                           
                                        <b>Mata Pelajaran: {this.state.namaMapel}</b>
                                    </div>

                                    <div className="col-md-4">&nbsp;</div>
                                </div> 

                                <div className="row">
                                    <br></br>
                                </div>
                            
                                {this.showAlert()}

                                <table className="table table-striped" id="myTable">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Nama Siswa</th>
                                            <th>Soal</th>
                                            <th>Benar</th>
                                            <th>Salah</th>
                                            <th>Skor</th>
                                            <th>Status</th>
                                            <th>Detail</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        { this.renderListReport() }
                                    </tbody>
                                </table>
                            </div>
                        }  
                        {this.loading()}
                    </div>
                </div>
            </div>
        );
    }

    loading = () => {
        if(this.state.isLoading){
            return(
                <Loader />
            )
        }
    }

    showAlert = () => {
        if(this.state.alertShow) {
            return(
                <Alert severity="info"
                    action={
                        <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => this.setState({alertShow:false})}
                        >
                        <i class="fa fa-times" aria-hidden="true"></i>
                        </IconButton>
                    }
                    >
                    <strong>{this.state.alertMessage}</strong>
                </Alert>
            )
        }
        
    }


}
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(Homework); 